<template>
  <v-menu v-model="menuDatetime" :close-on-content-click="false" transition="scale-transition" offset-y>
    <template #activator="{ on, attrs }">
      <div class="input-group">
        <input
          :id="id"
          type="text"
          v-model="txtDateTime"
          class="form-control bg-white"
          :placeholder="placeholder"
          :class="classes"
          v-bind="attrs"
          v-on="on"
          @blur="handleBlur"
        />
        <!-- <div class="input-group-prepend" v-bind="attrs" v-on="on">
          <div class="input-group-text"><i class="fa-solid fa-calendar-days"></i></div>
        </div> -->
      </div>
    </template>
    <v-date-picker
      v-model="dateSelect"
      locale="vi-vn"
      year-icon="mdi-calendar-blank"
      prev-icon="mdi-skip-previous"
      next-icon="mdi-skip-next"
      class="w-100"
      @input="menuDatetime = false"
    ></v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "DatePickerView",
  props: {
    classes: {
      type: Object,
      default: null,
    },
    placeholder: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
      required: true,
    },
  },
  data() {
    return {
      dateSelect: "",
      menuDatetime: false,
      txtDateTime: "",
    };
  },
  watch: {
    dateSelect(value) {
      this.$emit("callbackFunction", value);
      if(this.formatDateDDMMYYY(value) != this.txtDateTime){
        this.txtDateTime = this.formatDateDDMMYYY(value);
      }
    },
    txtDateTime(value) {
      const date_regex =/^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/;
      if(value.split("/").length === 3 && value.match(date_regex)){
        const [day, month, year] = value.split('/');
        this.dateSelect = [year, month, day].join('-');
      }
    },
  },
  methods: {
    formatDateDDMMYYY(date) {
      const d = new Date(date);
      let month = "" + (d.getMonth() + 1);
      let day = "" + d.getDate();
      const year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join("/");
    },
    formatDate(date) {
      let d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    handleBlur() {
      this.txtDateTime = this.formatDateDDMMYYY(this.dateSelect)
    }
  },
  created() {
    if(this.value) {
      this.dateSelect = this.formatDate(this.value);
      this.txtDateTime = this.formatDateDDMMYYY(this.value);
    }
  },
};
</script>

<style scoped></style>
